import { Children } from 'react';
import { Box, Heading, Text } from 'tombac';
import { SharedLimitsSummary } from "./SharedLimitsSummary";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ProductPackages = ({
  children
}) => {
  const packagedProductsExist = Children.count(children);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      $display: "flex",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ProductPackages.tsx",
      "data-sentry-element": "Box",
      children: /*#__PURE__*/_jsx(Heading, {
        level: 3,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "ProductPackages.tsx",
        "data-sentry-element": "Heading",
        children: "Packages"
      })
    }), packagedProductsExist ? /*#__PURE__*/_jsxs("div", {
      className: "ProductList",
      children: [children, /*#__PURE__*/_jsx(SharedLimitsSummary, {})]
    }) : /*#__PURE__*/_jsx(Text, {
      $mb: "3sp",
      children: "No package had been added."
    })]
  });
};